import { matchPath } from 'react-router-dom';

import * as ROUTES from '#client/constants/routes';

const APP_SECTION_ROUTES = {
  account: [ROUTES.accountSettings, ROUTES.download, ROUTES.help],
  assistant: [ROUTES.assistantUI, '/guide/*'],
  banking: [ROUTES.entityBanking],
  business: [ROUTES.billing, ROUTES.entities, ROUTES.entityProfile, ROUTES.entityOrders, ROUTES.entitySubscriptions],
  compliance: [
    // Match the whole /compliance subtree rather than enumerating each page. Enumerating meant every
    // compliance-ui page added after the list was written fell through to 'unknown' — the registered
    // agent page, the hub landing page itself, and business-licenses sub-paths all did.
    // getAppOrigin already matches this subtree the same way, which is why app_origin stayed correct
    // while app_section did not.
    ROUTES.entityCompliance,
    ROUTES.entityWorryFreeCompliance,
  ],
  documents: [ROUTES.entityBusinessDocuments, ROUTES.entityDocumentTemplates],
  education: [ROUTES.education],
  growth: [ROUTES.entityMarketingTools],
  home: [ROUTES.entity, ROUTES.dashboard, ROUTES.logout],
  products: [ROUTES.entityProducts, ROUTES.entityProductLanding],
  tax_services: [ROUTES.taxServices],
  finance_hub: [ROUTES.entityFinanceHub, ROUTES.entityFinanceHubLinkedAccounts],
  money: [ROUTES.entityMoney],
  invoicing: [ROUTES.invoicingUI],
  subscription_cancel: [ROUTES.entitySubscriptionCancel],
  failed_payment_recovery: [ROUTES.invoicePayment, ROUTES.invoicePaymentReturn],
};

/**
 * Returns the app section based on the given pathname.
 *
 * @param {string} pathname - The input pathname to match against APP_SECTION_ROUTES.
 * @returns {string} The matching page section or 'unknown', if no match is found.
 */
function getAppSection(pathname) {
  const section = Object.entries(APP_SECTION_ROUTES).find(([, routes]) =>
    routes.find((route) => matchPath(route, pathname)),
  )?.[0];

  return section || 'unknown';
}

export { getAppSection };
